export const MIN_BRIGHTNESS = -150;
export const MAX_BRIGHTNESS = 150;
export const MIN_CONTRAST = -50;
export const MAX_CONTRAST = 100;
